angular.module('impactx.datedisplay').controller('DateDisplayCtrl', [
    '$scope',
    'AppConfiguration',
    '$context',
    DateDisplayController]);

function DateDisplayController($scope, AppConfiguration, $context) {
    var self = this;
    var date = new Date();

    initialize();

    function initialize() {
        self.showDate = AppConfiguration.get('showDateInMenu');
        if (self.showDate) {
            initializeWatcher();
        }
    }

    function initializeWatcher() {
        $scope.$on('loginSuccess', function () {
            var languageWatcher = $scope.$watch(function () {
                return $context.user.language;
            }, function (newValue) {
                if (newValue) {
                    self.currentDate = date.toLocaleDateString(newValue, {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    });
                    languageWatcher();
                }
            });
        });
    }
}